import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { btnS } from '../../../../shared/globalStyling/style';
import { Input, Space } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import GlobalButton from '../../../../shared/globalStyling/Button';

const ImpressionTableSearch = ({ location, history }) => {
  const params = new URLSearchParams(location.search);
  const tagIdSearch = params.get('impressionTagId');
  const nameSearch = params.get('impressionName');

  const [tagIdSearchValues, setTagIdSearchValue] = useState();
  const [nameSearchValues, setNameSearchValue] = useState();

  return (
    <Space className="ant-space-xs-vertical ant-space-md-horizontal" size={'small'}>
      <Input
        placeholder={'Search By Tag ID'}
        value={tagIdSearchValues}
        onChange={(e) => {
          const value = e.target.value;
          setTagIdSearchValue(value);

          if (value === '') {
            params.delete('impressionTagId');
            history.push({
              pathname: location.pathname,
              search: `?${params.toString()}`,
            });
          }
        }}
        onPressEnter={(val) => {
          const searchValue = val.target.value;
          if (tagIdSearch) params.delete('impressionTagId');

          if (searchValue !== '') {
            params.append('impressionTagId', searchValue);
          } else {
            params.delete('impressionTagId');
          }

          history.push({
            pathname: location.pathname,
            search: `?${params.toString()}`,
          });
        }}
        defaultValue={tagIdSearch}
        allowClear
      />
      <Input.Search
        placeholder={'Search By Name'}
        value={nameSearchValues}
        onChange={(e) => setNameSearchValue(e.target.value)}
        onSearch={(searchValue) => {
          if (nameSearch) {
            params.delete('impressionName');
          }

          if (searchValue !== '') {
            params.append('impressionName', searchValue);
          } else {
            params.delete('impressionName');
          }

          history.push({
            pathname: location.pathname,
            search: `?${params.toString()}`,
          });
        }}
        defaultValue={nameSearch}
        allowClear
      />

      <GlobalButton
        shape="round"
        style={btnS}
        type={'default'}
        onClick={() => {
          if (tagIdSearch) params.delete('impressionTagId');
          if (nameSearch) params.delete('impressionName');

          setNameSearchValue();
          setTagIdSearchValue();
          history.push({
            pathname: location.pathname,
            search: `?${params.toString()}`,
          });
        }}
        disabled={!tagIdSearch && !nameSearch}
        icon={<CloseOutlined />}
      >
        Clear
      </GlobalButton>
    </Space>
  );
};

export default withRouter(ImpressionTableSearch);
